const beneficios = [
  {
    icono: 'ri-flashlight-line',
    titulo: 'Alta Eficiencia de Separación',
    descripcion: 'Rompe emulsiones agua-crudo con rapidez excepcional, incluso en crudos pesados y extrapesados de la Faja.',
  },
  {
    icono: 'ri-drop-line',
    titulo: 'Baja Dosificación',
    descripcion: 'Formulación concentrada que reduce el volumen requerido por barril, optimizando costos operativos.',
  },
  {
    icono: 'ri-temp-hot-line',
    titulo: 'Estabilidad Térmica',
    descripcion: 'Mantiene su efectividad en amplios rangos de temperatura, desde superficie hasta condiciones de fondo de pozo.',
  },
  {
    icono: 'ri-shield-check-line',
    titulo: 'Compatibilidad Total',
    descripcion: 'Formulado para ser compatible con sistemas de producción existentes sin interferir con otros químicos del proceso.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Beneficios <span className="text-primary-500">Clave</span>
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              Razones por las que los principales operadores de la Faja Petrolífera del Orinoco confían en nuestro demulsificante.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {beneficios.map((beneficio) => (
              <div
                key={beneficio.titulo}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60 hover:border-primary-200/50 transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4">
                  <i className={`${beneficio.icono} text-lg`} />
                </div>
                <h4 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  {beneficio.titulo}
                </h4>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed text-justify">
                  {beneficio.descripcion}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = '/#contact';
              }}
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Solicitar Cotización del Demulsificante
              <i className="ri-arrow-right-line" />
            </a>
            <p className="text-foreground-400 text-xs mt-4">
              Consulte por disponibilidad y precios para su campo petrolero
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 mt-3">
              <a href="tel:+584129080594" className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line text-sm"></i>
                +58 412 908 0594
              </a>
              <a href="tel:+584121019460" className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line text-sm"></i>
                +58 412 101 9460
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}